import { Controller } from '@hotwired/stimulus';

// Filters the "Product" select in the footprint product mapping form so
// that only products belonging to providers which have the selected
// footprint available are shown.
export default class extends Controller {
  static targets = ['footprint', 'product'];
  static values = { providersByFootprint: Object };

  connect() {
    this.filter();
  }

  filter() {
    const footprintId = this.footprintTarget.value;
    const allowedProviderIds = footprintId
      ? (this.providersByFootprintValue[footprintId] || []).map(String)
      : null;
    let selectedOptionHidden = false;

    this.productTarget.querySelectorAll('optgroup').forEach((optgroup) => {
      const visible =
        !allowedProviderIds ||
        allowedProviderIds.includes(optgroup.dataset.providerId);
      optgroup.hidden = !visible;

      optgroup.querySelectorAll('option').forEach((option) => {
        option.hidden = !visible;
        option.disabled = !visible;
        if (!visible && option.selected) selectedOptionHidden = true;
      });
    });

    if (selectedOptionHidden) this.productTarget.value = '';
  }
}
